//**** REACT
import React, { useState, useContext, useLayoutEffect } from 'react'


// *** Services
import { IDVActions } from "services"
// *** Core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
// *** Contexto
import { UsuarioContext } from 'config/context/UsuarioProvider'
// *** Imagenes
import iphone from "assets/img/img-planes.jpg";
// *** @material-ui/core components
import ErrorIcon from '@material-ui/icons/Error';
import { makeStyles } from "@material-ui/core/styles";
import featuresStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle.js";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
const useStyles = makeStyles(basicsStyle);
const useStyles2 = makeStyles(featuresStyle);


export default function CargarPreguntas() {
  const { usuario, question, setquestion } = useContext(UsuarioContext);
  const classes2 = useStyles2();
  const classes = useStyles();
  const [radioSelected, setRadioSelected] = useState([0])
  useLayoutEffect(() => {


  }, []);

  function changeRadio(id, key, value) {
    radioSelected[id] = value
    setRadioSelected(radioSelected)
    var arrayDeCadenas = value.split('-');
    for (let i = 0; i < question.question[key].answers.length; i++) {
      question.question[key].answers[i].isSelected = "false";
    }
    question.question[key].answers[arrayDeCadenas[1]].isSelected = "true"
    setquestion({ ...question })
  }

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <div className={classes2.features3}>
            <img src={iphone} alt="..." />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.title}>
                <h3 style={{fontWeight: "400"}}>Validación de Identidad</h3>
              </div>
              <div style={{ paddingTop: 10 }}></div>
            </GridItem>
            {question.question === null && question.retNo != null ?
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.title} style={{ textAlign: "justify" }}>
                  <h3><ErrorIcon color="secondary" style={{ fontSize: 22 }} />
                  No se pudo validar su identidad. Uno de nuestros ejecutivos se pondrá en contacto a la brevedad. Agradeceremos enviar cédula de identidad vigente al correo soporte@firmadox.cl. Para mayor información puede contactarse al +56226179201.
                  </h3>
                </div>
              </GridItem>
              : null}

            {question.question && question.question.map((questionProp, key) =>
              <GridItem xs={12} sm={12} md={12} style={{ paddingBottom: 20 }}>
                <FormControl component="fieldset">
                  <FormLabel component="legend">{questionProp.text}</FormLabel>
                  <RadioGroup aria-label="gender" name={"preguntas-" + questionProp.id} value={radioSelected["radio-" + questionProp.id]} onChange={(index, valor) => changeRadio("radio-" + questionProp.id, key, valor)}>
                    {questionProp.answers && questionProp.answers.map((answers, keyAnswer) =>
                      <FormControlLabel value={key + "-" + keyAnswer} control={<Radio />} label={answers.text} />
                    )}
                  </RadioGroup>
                </FormControl>
              </GridItem>
            )}
          </GridContainer>
        </GridItem>
      </GridContainer>

    </div>
  )
}
